<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="8">
        <v-btn
          v-if="!hideCreateNewEventButton"
          class="pa-5"
          rounded
          color="primary"
          elevation="0"
          @click="createEventLink(false)"
        >
          <v-icon left>add</v-icon> Create New Link
        </v-btn>

        <v-btn
            v-if="!hideCreateNewEventButton && (businessProfile.businessName == 'Pappyon' || businessProfile.businessName == 'My test business')"
            class="pa-5 ml-4"
            rounded
            color="primary"
            elevation="0"
            @click="createEventLink(true)"
        >
          <v-icon left>add</v-icon> Create Travel Itinerary
        </v-btn>
      </v-col>
      <v-col md="4" sm="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          outlined
          single-line
          hide-details
          rounded
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-data-table
          :headers="headers"
          :items="multiConnectEvents"
          :search="search"
          class="multi-connect-table"
          @click:row="handleEdit"
          :items-per-page="8"
        >
          <template v-slot:item.displayImageURL="{ item }">
            <UserAvatar
              v-if="item.name || item.displayImageURL"
              :usersInitials="item.name[0]"
              :displayImageUrl="item.displayImageURL"
            />
            <v-sheet
              v-else
              flat
              class="badge-image circle d-flex justify-center align-center"
              :height="50"
              :width="50"
            >
              <v-sheet
                :class="[
                  'circle d-flex justify-center align-center dashed-border',
                ]"
                :height="50"
                :width="50"
              >
                <div class="grey--text text-center logo-text">
                  Add your logo
                </div>
              </v-sheet>
            </v-sheet>
          </template>

          <template v-slot:item.name="{ item }">
            {{ getMultiConnectEventName(item) }}
            <br />
            <div class="text-capitalize text-caption">
              {{ item.type }}
            </div>
            <br />
            <div v-if="item.noOfConnections != undefined">
              {{ getNoOfConnections(item.noOfConnections) }}
            </div>
          </template>
          <template slot="no-data">
            <div v-if="filter == 'All'">You don't have any events</div>
            <div v-else>
              You don't have any {{ filter.toLowerCase() }} events
            </div>
          </template>
          <template slot="header.info">
            <div class="d-flex align-center justify-space-between">
              <span>Event Privacy</span>
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span
                  >This reflects the period of time your event attendees will
                  have to start connecting with each other via your Multi
                  Connect link. It is advisable to encourage your event
                  attendees to opt in to your link prior to commencement of your
                  event.</span
                >
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              label
              :color="item.getStatusColor()"
              :textColor="item.getStatusTextColor()"
              class="font-weight-medium"
              dark
              small
              >{{ item.getStatus() }}</v-chip
            >
          </template>

          <template v-slot:item.info="{ item }">
            <div>
              <div>
                <div>
                  {{ item.linkPrivacy }}
                </div>
              </div>
              <br />
              <!-- <div>
                <div class="text--secondary">Expires:</div>
                <div>
                  {{ getEventExpirationDateTime(item) }}
                </div>
              </div> -->
            </div>
          </template>

          <template v-slot:item.eventDateTime="{ item }">
            <div>
              <div>
                <div class="text--secondary">Start:</div>
                <div>
                  {{ getEventStartDateTime(item) }}
                </div>
              </div>
              <br />
              <div>
                <div class="text--secondary">End:</div>
                <div>
                  {{ getEventEndDateTime(item) }}
                </div>
              </div>
            </div>
          </template>

          <template v-slot:item.type="{ item }">
            <span class="text-capitalize">{{ item.type }}</span>
          </template>

          <template v-slot:item.createdBy="{ item }">
            <span class="text-capitalize text-no-wrap">{{
              item.createdBy
            }}</span
            >&nbsp;<span
              v-if="item.createdAt != null"
              class="text-capitalize"
              >{{ item.createdAt.toLocaleDateString() }}</span
            >
          </template>

          <template v-slot:item.action="{ item }">
            <!-- <v-menu transition="slide-y-transition" bottom left offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav>
                          <v-list-item @click="handleEdit(item)">
                            <v-list-item-title>Edit event</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="copyLink(item)" v-if="item.linkPrivacy == 'Public'">
                            <v-list-item-title>Copy event link</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="viewAttendees(item)">
                            <v-list-item-title>View registrants</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="viewInvitees(item)">
                            <v-list-item-title>View invitees</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="showConfirmation(item)">
                            <v-list-item-title>Delete Event</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu> -->

            <SubMenu
              name="New Menu"
              :data="item"
              :menu-items="fileMenuItems"
              @sub-menu-click="onMenuItemClick"
              :isOpenOnHover="false"
            />
          </template>

          <template
            v-if="isSuperUserDashboard"
            v-slot:item.businessProfile="{ item }"
          >
            <div>{{ getBusinessProfile(item.businessProfileId) }}</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <PurchaseMultiConnectCreditsDialog
      :showDialog="purchaseMultiConnectCreditsDialog"
      @closeDialog="purchaseMultiConnectCreditsDialog = false"
    />
    <ConfirmationDialog
      :show="showConfirmationDialog"
      title="Delete event?"
      content="Are you sure you want to delete this event? All information related to this event will be deleted."
      @click="handleDelete"
      @closeDialog="showConfirmationDialog = false"
      buttonText="Delete event"
    />

    <v-snackbar v-model="snackbar" left multi-line :timeout="snackbarTimeout">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar = false"
          top
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <CreateEventDialog
      :show="showCreateEventDialog"
      :isSuperUserDashboard="isSuperUserDashboard"
      :is-travel-event="isTravelEvent"
      @close="showCreateEventDialog = false"
    />

    <!-- <MultiConnectOptIn v-else /> -->
  </div>
</template>

<script>
import PurchaseMultiConnectCreditsDialog from "@/components/PurchaseMultiConnectCreditsDialog";
import Event from "@/models/Event";
import Utility from "@/shared/utility";
import { mapGetters, mapActions } from "vuex";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import MultiConnectOptIn from "@/components/MultiConnect/MultiConnectOptIn";
import SubMenu from "@/components/SubMenu";
import UserAvatar from "@/components/UserAvatar";
import CreateEventDialog from "./CreateEventDialog";

export default {
  props: {
    multiConnectEvents: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // cardHolders: {
    //   type: Array,
    //   default: function () {
    //     return [];
    //   },
    // },
    isSuperUserDashboard: { type: Boolean, default: false },
    hideCreateNewEventButton: { type: Boolean, default: false },
    hideActionsMenu: { type: Boolean, default: false },
  },
  components: {
    PurchaseMultiConnectCreditsDialog,
    ConfirmationDialog,
    MultiConnectOptIn,
    SubMenu,
    UserAvatar,
    CreateEventDialog,
  },
  computed: {
    ...mapGetters([
      "currentEvent",
      "selectedBusinessProfileId",
      "businessProfile",
      "totalNoOfConnections",
      "businessProfiles",
    ]),
    filteredEvents: function () {
      if (this.filter == "All") {
        return this.events;
      } else {
        let filteredEvents = [];
        this.events.forEach((event) => {
          if (event.getStatus() == this.filter) {
            filteredEvents.push(event);
          }
        });
        return filteredEvents;
      }
    },
    itemClass() {
      return "vertical-align-top";
    },
  },
  created() {
    this.clearCurrentEvent();

    if (this.isSuperUserDashboard) {
      this.headers.splice(6, 0, {
        text: "Business Profile",
        value: "businessProfile",
        align: "start",
      });
    }

    //Show actions for MC Table
    if (!this.hideActionsMenu) {
      this.headers.push({ text: "", value: "action" });
    }
  },
  data() {
    return {
      isTravelEvent: false,
      headers: [
        {
          text: "",
          value: "displayImageURL",
          align: "start",
        },
        {
          text: "Event Name",
          value: "name",
          align: "start",
        },
        { text: "", value: "status", align: "start" },

        {
          text: "Event Date and Time",
          value: "eventDateTime",
          align: "start",
        },
        { text: "Link Activation Period", value: "info", align: "start" },
        {
          text: "Created",
          value: "createdBy",
          align: "start",
        },
        // {
        //   text: "Date",
        //   value: "createdAt",
        //   align: "start",
        // },
      ],
      addEditMultiConnectDialog: false,
      purchaseMultiConnectCreditsDialog: false,
      event: {},
      events: [],
      firstEventOnLoad: null,
      response: false,
      snackbar: false,
      snackbarTimeout: 6000,
      snackbarText: "",
      filter: "All",
      removeEvent: {},
      showConfirmationDialog: false,
      search: "",
      unsubscribeEventsSnapshot: null,
      isSubscribedToMultiConnect: false,
      //Start: submenu
      fileMenuItems: [
        {
          name: "Edit event",

          action: this.handleEdit,
        },

        // { name: "Copy event link", action: this.copyLink },
        {
          name: "View registrants",
          action: this.viewAttendees,
        },
        {
          name: "View invitees",
          action: this.viewInvitees,
        },
        {
          name: "View connections",
          action: this.viewConnections,
        },
        {
          name: "Delete Event",
          action: this.showConfirmation,
        },

        {
          name: "Share",
          menu: [
            { name: "1.1" },
            { name: "1.2" },
            {
              name: "Sub-menu 2",
              menu: [
                { name: "2.1" },
                { name: "2.2" },
                {
                  name: "Sub-menu 3",
                  menu: [
                    { name: "3.1" },
                    { name: "3.2" },
                    {
                      name: "Sub-menu 4",
                      menu: [{ name: "4.1" }, { name: "4.2" }, { name: "4.3" }],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      showCreateEventDialog: false,
      //End: submenu
    };
  },

  methods: {
    ...mapActions([
      "setCurrentEvent",
      "clearCurrentEvent",
      "onMultiConnectEventsSnapshot",
      "clearMultiConnectEvents",
    ]),

    async createEventLink(isTravelEvent) {
      console.log(isTravelEvent);
      if (isTravelEvent) {
        this.isTravelEvent = true;
      } else {
        this.isTravelEvent = false;
      }
      if (this.isSuperUserDashboard) {
        this.event = new Event({
          isCreationInProgress: true,
        });
      } else {
        this.event = new Event({
          businessProfileId: this.selectedBusinessProfileId,
          hostName: this.businessProfile.businessName,
          isCreationInProgress: !isTravelEvent,
          eventCategory: isTravelEvent ? "travel" : "multiConnect",
          notesEnabled: false,
          programFiltersEnabled: !isTravelEvent,
        });
      }

      this.setCurrentEvent(this.event);

      //generate public link for event
      // this.currentEvent.generatePublicLink();

      this.currentEvent.generateEventId();

      this.showCreateEventDialog = true;
    },
    handleEdit(event) {
      this.setCurrentEvent(event);
      this.currentEvent.currentTab = 0;
      let multiConnectRoute;

      console.log(
        " this.currentEvent.isWizardCompleted: ",
        this.currentEvent.isCreationInProgress
      );

      if (this.currentEvent.isCreationInProgress) {
        multiConnectRoute = {
          name: "addMultiConnect",
          params: { eventId: this.currentEvent.id },
        };
      } else {
        multiConnectRoute = {
          name: "editMultiConnect",
          params: { eventId: this.currentEvent.id },
        };

        if (this.isSuperUserDashboard)
          editMultiConnectRoute.query = { privilege: "superUser" };
      }

      this.$router.push(multiConnectRoute);
    },
    async handleDocumentChange(change) {
      this.firstEventOnLoad = change.doc;
      let addedEvent;
      if (change.type === "added" || change.type == "modified") {
        //let data = change.doc.data({ serverTimestamps: "estimate" });
        addedEvent = Event.fromFireStore(change.doc);
      }
      if (change.type === "added") {
        if (
          this.events.length != 0 &&
          addedEvent.createdAt > this.events[0].createdAt
        ) {
          this.events.unshift(addedEvent);
        } else {
          this.events.push(addedEvent);
          this.lastVisible = change.doc;
        }
      } else if (change.type == "modified") {
        //Replace the old object within the array with the modified object
        this.events.forEach((item, index) => {
          if (item.id == change.doc.id) {
            this.events.splice(index, 1, addedEvent);
          }
        });
      } else if (change.type == "removed") {
        //Remove the object from the array
        this.events.forEach((item, index) => {
          if (item.id == change.doc.id) {
            this.events.splice(index, 1);
          }
        });
      }
    },

    showConfirmation(event) {
      this.removeEvent = event;
      this.showConfirmationDialog = true;
    },

    handleDelete() {
      //Delete the event
      this.response = this.removeEvent.remove();
      this.showConfirmationDialog = false;
      this.snackbarText = this.response
        ? "Deleted successfully!"
        : "Something went wrong. Please try again.";

      this.snackbar = true;
    },
    formattedDateTime(dateTime) {
      return Utility.formatDateTime(dateTime);
    },

    copyLink(event) {
      Utility.copyToClipboard(event.dynamicLink);
      this.snackbarText = "Copied to clipboard!";
      this.snackbarTimeout = 5000;
      this.snackbar = true;
    },

    viewAttendees(event) {
      this.setCurrentEvent(event);

      let multiConnectRoute = {
        name: "editMultiConnect",
        params: { eventId: this.currentEvent.id },
        query: { tab: 4 },
      };

      if (this.isSuperUserDashboard)
        multiConnectRoute.query["privilege"] = "superUser";

      this.$router.push(multiConnectRoute);
    },
    viewInvitees(event) {
      this.setCurrentEvent(event);

      let multiConnectRoute = {
        name: "editMultiConnect",
        params: { eventId: this.currentEvent.id },
        query: { tab: 3 },
      };

      if (this.isSuperUserDashboard)
        multiConnectRoute.query["privilege"] = "superUser";

      this.$router.push(multiConnectRoute);
    },
    getNoOfConnections(noOfConnections) {
      if (noOfConnections == 1) return noOfConnections + " connection";
      else return noOfConnections + " connections";
    },
    onMenuItemClick(item, data) {
      // console.log(`onMenuItemClick(), item=${item}, data=${data}`);
      if (item.action) {
        item.action(data);
      }
    },
    getBusinessProfile(businessProfileId) {
      let businessProfile = this.businessProfiles?.find((businessProfile) => {
        return businessProfileId == businessProfile?.id;
      });

      return businessProfile?.businessName || "-";
    },
    viewConnections(event) {
      this.setCurrentEvent(event);
      this.$router.push({
        name: "multiConnectConnectionList",
        params: { eventId: event.id },
      });
    },
    getEventActivationDateTime(item) {
      if (item.getFormattedEventActivationDateTime())
        return (
          item.getFormattedEventActivationDateTime() +
          " (" +
          item.timezone +
          ")"
        );
      else return "-";
    },
    getEventExpirationDateTime(item) {
      if (item.getFormattedEventExpirationDateTime())
        return (
          item.getFormattedEventExpirationDateTime() +
          " (" +
          item.timezone +
          ")"
        );
      else return "-";
    },
    getEventStartDateTime(item) {
      if (item.getFormattedEventStartDate())
        return item.getFormattedEventStartDate() + " (" + item.timezone + ")";
      else return "-";
    },
    getEventEndDateTime(item) {
      if (item.getFormattedEventEndDate())
        return item.getFormattedEventEndDate() + " (" + item.timezone + ")";
      else return "-";
    },
    getMultiConnectEventName(item) {
      if (item.name) return item.name;
      else return "Untitled Event";
    },
  },
};
</script>

<style>
.multi-connect-table tr td {
  vertical-align: top !important;
  padding: 1.5rem 0.5rem !important;
  cursor: pointer;
}
</style>
